import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DatepickerFeatureComponent } from './datepicker-feature.component';

@NgModule({
  imports: [CommonModule, FormsModule, NgbModule],
  declarations: [DatepickerFeatureComponent],
  exports: [DatepickerFeatureComponent],
})
export class DatepickerFeatureModule {}
